<template>
    <div class="content work_flow_wrap" v-loading.fullscreen.lock="fullscreenLoading">
      <div class="tab-wrap">
        <el-tabs v-model="page.listType" @tab-click="getList">
          <el-tab-pane label="全部流程" name="0"> </el-tab-pane>
          <el-tab-pane label="待处理" name="4"></el-tab-pane>
          <el-tab-pane label="已处理" name="2"></el-tab-pane>
          <el-tab-pane label="我收到的" name="3"></el-tab-pane>
          <el-tab-pane label="我发起的" name="1"></el-tab-pane>
        </el-tabs>
      </div>
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="6"
            ><div class="search-area-div">药企名称：</div>
            <el-select size="mini" filterable clearable v-model="page.tenantGuid" class="ipt-sty" placeholder="请选择" @change="changeTenant">
              <el-option v-for="item in tenantList" :key="item.sendTenantGuid" :label="item.sendTenantName" :value="item.sendTenantGuid">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6">
            <div class="search-area-div">组织名称：</div>
            <el-select
            size="mini"
              v-model="page.organisationGuids"
              placeholder="请选择组织名称"
              class="ipt-sty"
              clearable
              filterable
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in organisationList"
                :key="item.guid"
                :label="item.organisationName"
                :value="item.guid"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="6"
            ><div class="search-area-div">核算月：</div>
            <el-date-picker
            size="mini"
              v-model="page.accountMonth"
              class="ipt-sty"
              type="month"
              value-format="yyyy-MM"
              placeholder="请选择"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="6">
            <el-button
              size="mini"
              type="text"
              @click="showMore = !showMore"
              :icon="showMore ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
            >
              {{ showMore ? '收起筛选' : '更多筛选' }}
            </el-button>
            <el-button size="mini" type="info" @click="getList(1)">搜索</el-button>
            <el-button size="mini" type="danger" @click="emptySearch">清空</el-button></el-col
          >
        </el-row>
        <el-row :gutter="24"  v-show="showMore">
          <el-col :span="6"
            ><div class="search-area-div">提交日期：</div>
            <el-date-picker
            size="mini"
                v-model="timeLists"
                class="ipt-sty"
                type="daterange"
                range-separator="至"
                value-format="yyyy-MM-dd"
                clearable
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
          </el-col>
          <el-col :span="6"
            ><div class="search-area-div">审批状态：</div>
            <el-select size="mini" filterable clearable v-model="page.approveState" class="ipt-sty" placeholder="请选择">
              <el-option v-for="item in approveStateOption" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
      <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px'" >
        <div class="button-area">
          <el-button icon="el-icon-plus" size="mini" type="info" @click="addData">流程审批申请</el-button>
        </div>
        <el-table :data="tableData" stripe border style="width: 100%" v-loading="tableLoading" :height="tableHeight">
          <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left">
            <template slot-scope="scope">
              <!-- {{ scope.$index + 1 }} -->
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            fixed="left"
            prop="flowNo"
            label="流程编号"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="110"
        >
          <template slot-scope="scope">{{ scope.row.bizApproveVO.flowNo || '-' }}</template>
        </el-table-column>

          <el-table-column
          fixed="left"
            prop="staffName"
            label="发起人"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="100"
          >
            <template slot-scope="scope">{{ scope.row.bizApproveVO.staffName || '-' }}</template>
          </el-table-column>
          
          <el-table-column
            prop="tenantName"
            label="药企名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="200"
          >
            <template slot-scope="scope">{{ scope.row.tenantName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="organisationName"
            label="组织名称"
            show-overflow-tooltip
            header-align="center"
            align="left"
            min-width="180"
          >
            <template slot-scope="scope">{{ scope.row.organisationName || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="accountMonth"
            label="核算月"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="80"
          >
            <template slot-scope="scope">{{ scope.row.accountMonth || '-' }}</template>
          </el-table-column>

          <el-table-column
            prop="staffNum"
            label="人数"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="100"
          >
            <template slot-scope="scope">{{ scope.row.staffNum || '-' }}</template>
          </el-table-column>
          <el-table-column
            prop="totalMoney"
            label="应付金额(元)"
            show-overflow-tooltip
            header-align="center"
            align="right"
            width="160"
          >
            <template slot-scope="scope">{{ scope.row.totalAmount  | numDigit}}</template>
          </el-table-column>
          <el-table-column
            prop="inputTime"
            label="提交时间"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.bizApproveVO.createTime | getTime }}</template>
          </el-table-column>
          <el-table-column prop="endTime" label="审批状态" header-align="center" align="center" width="80">
            <template slot-scope="scope"
              ><span :class="getStateShow(scope.row.bizApproveVO.approveState)">{{
                scope.row.bizApproveVO.approveState | approveState
              }}</span></template
            >
          </el-table-column>
          <el-table-column
            prop="approveTime"
            label="操作时间"
            show-overflow-tooltip
            header-align="center"
            align="left"
            width="140"
          >
            <template slot-scope="scope">{{ scope.row.bizApproveVO.approveTime | getTime }}</template>
          </el-table-column>
          <el-table-column prop="bank" width="200" label="操作" fixed="right" header-align="center" align="center">
            <template slot-scope="scope">
                <a
                class="txt-color"
                v-if="getListBtnState('detail', scope.row.bizApproveVO) == 'detail'"
                @click="editData(scope.row, 2)"
                >
                详情
                </a>
                <a
                class="txt-color"
                @click="handlePassClick(scope.row)"
                v-if="getListBtnState('approval',  scope.row.bizApproveVO) == 'approval'"
                >
                通过
                </a>
                <a
                class="txt-color"
                @click="
                    rejectDialogVisible = true;
                    approveSuggest = '';
                    form = scope.row.bizApproveVO;
                "
                v-if="getListBtnState('approval',  scope.row.bizApproveVO) == 'approval'"
                >
                驳回
                </a>
                <a class="txt-color" @click="toRevoke( scope.row.bizApproveVO)" v-if="getListBtnState('revoke', scope.row.bizApproveVO) == 'revoke'">
                撤销
                </a>
                <a
                class="txt-color"
                @click="editData(scope.row, 1)"
                v-if="getListBtnState('edit',  scope.row.bizApproveVO) == 'edit'"
                >
                编辑
                </a>
                <a
                class="txt-color"
                v-if="getListBtnState('del',  scope.row.bizApproveVO) == 'del'"
                @click="delData(scope.row.guid)"
                >
                删除
                </a>
                <a
                class="txt-color"
                v-if="getListBtnState('again', scope.row.bizApproveVO) == 'again'&& scope.row.bizApproveState!='D'"
                @click="editData(scope.row, 3)"
                >
                    重新提交
                </a>
            </template>
        </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff content-pagination-box"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
      <el-dialog title="驳回流程" :visible.sync="rejectDialogVisible" width="30%" top="15%">
        <el-input type="textarea" :rows="5" placeholder="输入驳回理由（必填）" v-model="approveSuggest" maxlength="100">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" class="w100f" @click="toRejectSubmit()">驳回</el-button>
        </span>
      </el-dialog>
      <el-dialog title="填写通过备注" :visible.sync="passDialogVisible" width="30%" top="15%">
        <el-input type="textarea" :rows="5" placeholder="请填写通过备注（选填）" v-model="approveSuggest" maxlength="100">
        </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button type="info" class="w100f" @click="toPassSubmit()">通过</el-button>
        </span>
      </el-dialog>
      <PassDialog 
          ref="passDialogRef"
          :showInvoiceDate="showInvoiceDate"
          @submit="handlePassSubmit"
      ></PassDialog>
    </div>
  </template>
  
  <script>
  import { route } from '@/api/apiRoute';
  import store from '@/store';
  import workFlowCommon from '@/uilt/workFlowCommon';
  import Bus from '../../router/bus.js'
  import PassDialog from './components/PassDialog.vue';
  export default {
    components: {
        PassDialog,
    },
    data() {
      return {
        organisationList:[],
        tableHeight: window.innerHeight - 320,
        contentMainHeight: window.innerHeight - 250,
        showMore: false, // 筛选项显示更多，默认否，最多显示三个
        flowType: '00026',
        fullscreenLoading: false,
        currentStaffGuid: null,
        tenantList: [], //公司名称
        timeLists:[],
        page: {
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            totalRows: 0,
            tenantGuid: null,
            organisationGuids: null,
            accountMonth: null,
            currentServiceTenantGuid: localStorage.guid,
            approveState: null,
            listType: '0',
            startTime: null,
            endTime: null,
        },
        tableLoading: false,
        tableData: [],
        height: window.innerHeight - 400,
        right: 'right',
        approveSuggest: '',
        passDialogVisible: false,
        showInvoiceDate: false,
        relevanceDetail: null,
        rejectDialogVisible: false,
        form: '',
        approveStateOption: [
          { label: '全部', value: '' },
          { label: '草稿中', value: 'N' },
          { label: '审批中', value: 'A' },
          { label: '已通过', value: 'Y' },
          { label: '已驳回', value: 'R' },
          { label: '已撤销', value: 'C' },
        ],
        isLastNode: false,
      };
    },
    activated(){
      this.getList();
      this.getTenantList();
    },
    created() {
      let userinfo = JSON.parse(localStorage.userInfo);
      this.currentStaffGuid = userinfo.staffGuid;
      this.getList();
      this.getTenantList();
    },
    watch: {
      showMore(val, oldVal) {
              if (val) {
                  this.tableHeight = window.innerHeight - 360;
                  this.contentMainHeight = window.innerHeight - 260;
                  return;
              }
              if (!val) {
                  this.tableHeight = window.innerHeight - 320;
                  this.contentMainHeight = window.innerHeight - 250;
                  return;
              }
          }
    },
    methods: {
      //获取操作按钮显隐
      getListBtnState(btnType, row) {
        let bizApproveVO = row;
        return workFlowCommon.getListBtnState(
          btnType,
          bizApproveVO.approveState,
          bizApproveVO.staffGuid,
          bizApproveVO.approveStaffGuids,
          this.currentStaffGuid,
        );
      },
      //获取审批状态
      getStateShow(approvalState) {
        return workFlowCommon.getStateClass(approvalState);
      },
      //新增
      addData() {
        this.$router.push({
          path:'/upstreamHedgingAdd',
          query:{ 
            productGuid : this.$route.query.productGuid
          }
        });
      },
      //获取药企
      getTenantList() {
        let self = this;
        let query = {
          isService: true,
          tenantGuid: localStorage.guid,
        };
        self.api
          .get(`/${serverConfig.msCustomerService}/tenant/data/get-tenant-operation-rel-list`, query)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.tenantList = res.data.data || [];
            } else {
              self.$message.error(res.data.msg);
            }
          });
      },
      tenantChange(val) {
        if (val) {
          this.organisationList = [];
          this.page.organisationGuidList = [];
          this.getOrganisationList(val);
        }
      },
      changeTenant(val){
        this.getOrganisationList(val)
      },
      //获取组织
      getOrganisationList(v) {
        let self = this;
        if(!v){
          return
        }
        let query = {
          pageIndex: 1,
          pageSize: -1,
          tenantGuid: v,
          sendTenantGuid: localStorage.guid,
        };
        self.api.postJson(`/${serverConfig.msPersonnelService}/organisation/data/get`, query).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.organisationList = res.data.data.records || [];
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      //清空
      emptySearch() {
        this.page = {
            pageIndex: 1,
            pageSize: 50,
            totalPage: 0,
            totalRows: 0,
            tenantGuid: null,
            organisationGuids: null,
            accountMonth: null,
            currentServiceTenantGuid: localStorage.guid,
            approveState: null,
            listType: '0',
            startTime: null,
            endTime: null,
        };
        this.timeLists = [];
        this.organisationList = [];
        this.getList(1);
      },
      //type 为1编辑 3重新提交 2为详情
      editData(row, type) {
        let { bizApproveVO } = row;
        let query = {
          guid: row.guid,
          approveStaffGuid: bizApproveVO.approveGuid,
          camundaInstanceId: bizApproveVO.camundaInstanceId,
          camundaDeploymentId: bizApproveVO.camundaDeploymentId,
          productGuid: this.$route.query.productGuid,
          detail: JSON.stringify(row)
        };
        this.$router.push({
          path: type == 1 || type == 3 ? '/upstreamHedgingAdd' : '/upstreamHedgingDetail',
          query,
        });
      },
      getList(type) {
        let self = this;
        if (type == 1) {
          self.page.pageIndex = 1;
        }
        self.tableLoading = true;
        self.page.currentTenantGuid = localStorage.guid;
        let query = JSON.parse(JSON.stringify(this.page));
        if (this.timeLists && this.timeLists.length > 0) {
          query.startTime = this.timeLists[0] + ' 00:00:00';
          query.endTime = this.timeLists[1] + ' 23:59:59';
        }
        if(self.page.accountMonth){
          query.accountMonth = query.accountMonth.replace('-','');
        }
        let userInfo = JSON.parse(localStorage.userInfo);
        query.staffGuid = userInfo.staffGuid;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/hedge/list`, query).then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records || [];
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      // 删除
      delData(guid) {
        var self = this;
        self
          .$confirm('删除后不可恢复，确定删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            self.api.postJson(`/${serverConfig.msSalesPerformService}/upstream/hedge/delete`, [guid]).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          });
      },
      //驳回提交
      toRejectSubmit() {
        let userinfo = JSON.parse(localStorage.userInfo);
        if (this.approveSuggest == '') {
          this.$message.error('请填写驳回理由！');
          return;
        }
        let query = {
          guid: this.form.approveGuid,
          flowType: this.flowType,
          approveSuggest: this.approveSuggest,
          approveStaffGuid: userinfo.staffGuid,
        };
        this.fullscreenLoading = true;
  
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/backup-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.rejectDialogVisible = false;
            this.$message.success('驳回成功！');
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      async getLastNode(row) {
        let self = this;
        let userinfo = JSON.parse(localStorage.userInfo);
        let query = {
          staffGuid: userinfo.staffGuid,
          deploymentId: row.bizApproveVO.camundaDeploymentId,
          processInstanceId: row.bizApproveVO.camundaInstanceId,
        };
        const { data } = await self.api.postJson(
          `/${serverConfig.msSalesPerformService}/work-flow/data/is-my-last-node`,
          query
        );
        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message.error(data.msg);
          return false;
        }
        this.isLastNode = data.data || false;
      },
      //通过
      async handlePassClick(row) {
        await this.getLastNode(row);
        this.form = row.bizApproveVO;
        this.form.guid = row.guid;
        this.approveSuggest = '';
        this.relevanceDetail = await this.getRelationDetail(row.hedgeRelationInfoList || []);
        if (row?.isHedgeInvoice == 'N') {
          this.showInvoiceDate = false;
        }
        if (row?.isHedgeInvoice == 'Y') {
          const hasInvoiceApply = row.hedgeRelationInfoList?.some(item => item.flowType === '00018');
          const hasApplyInvoice = this.relevanceDetail?.isApplyInvoice == 'Y';
          this.showInvoiceDate = hasInvoiceApply || hasApplyInvoice;
        }

        if (this.isLastNode) {
          this.$refs.passDialogRef.open();
        } else {
          this.passDialogVisible = true;
          this.approveSuggest = '';
        }
      },
      // 获取关联详情
      async getRelationDetail(relevanceList) {
        const detailUrlMap = {
          '00017': '/upstream/payment-ticket/detail?guid=',
          '00018': '/upstream/payment-invoice-apply/detail?guid=',
        };
        const relationItem = relevanceList.find(item => detailUrlMap[item.flowType]);

        if (!relationItem) {
          return null;
        }

        const { data } = await this.api.get(
          `/${serverConfig.msSalesPerformService}${detailUrlMap[relationItem.flowType]}${relationItem.guid}`
        );

        if (data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.error(data.msg);
          return null;
        }

        return {
          ...data.data,
        };
      },
      //通过
      toPassSubmit() {
        let userinfo = JSON.parse(localStorage.userInfo);
        let query = {
          guid: this.form.approveGuid,
          flowType: this.flowType,
          approveSuggest: this.approveSuggest,
          approveStaffGuid: userinfo.staffGuid,
        };
        this.fullscreenLoading = true;
        this.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/allow-flow`, query).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.passDialogVisible = false;
            this.$message.success('审批通过！');
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      },
      /**
       * 最后节点通过提交
       */
      async handlePassSubmit(data) {
        let userinfo = JSON.parse(localStorage.userInfo);
        let query = {
          guid: this.form.guid,
          flowType: this.flowType,
          approveSuggest: data.approveSuggest,
          approveStaffGuid: userinfo.staffGuid,
          invoiceDate: data.invoiceDate,
          approveGuid: this.form.approveGuid,
        };
        this.fullscreenLoading = true;
        const res = await this.api.postJson(
          `/${serverConfig.msSalesPerformService}/upstream/hedge/last-flow`,
          query
        );
        this.fullscreenLoading = false;
        if (res.data.code != serverConfig.REQUIRE_SUCCESS_CODE) {
          return this.$message.error(res.data.msg);
        }
        this.$refs.passDialogRef.close();
        this.$message.success("审批通过！");
        this.getList();
      },
      //撤销
      toRevoke(form) {
        let self = this;
        this.$confirm('确定撤销吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            let query = {
              guid: form.approveGuid,
              flowType: this.flowType,
              approveStaffGuid: form.staffGuid,
            };
            self.fullscreenLoading = true;
            self.api.postJson(`/${serverConfig.msSalesPerformService}/work-flow/data/canal-flow`, query).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.fullscreenLoading = false;
                self.$message.success('撤销成功！');
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {
            self.$message({
              type: 'info',
              message: '已取消操作！',
            });
          });
      },
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        let self = this;
        self.page.pageIndex = val;
        this.getList();
      },
    },
  };
  </script>
  <style scoped>
  .el-table /deep/ .el-input__inner {
    height: 40px;
    line-height: 40px;
  }
  /deep/ .el-checkbox__label {
    display: none;
  }
  .attach-sty {
    width: 170px;
    float: left;
    margin-top: 15px;
    text-align: center;
  }
  .checkbox-img-sty {
    border: 1px solid #dcdfe6;
    width: 16px;
    height: 16px;
    border-radius: 2px;
    cursor: pointer;
  }
  /deep/ .el-step__icon.is-text {
    border-radius: 50%;
    border-color: #4fa1a4;
    border-color: inherit;
  }
  /deep/ .el-step__icon-inner {
    color: #4fa1a4;
  }
  /deep/ .el-step__title.is-process {
    color: #4fa1a4;
  }
  .el-col-6 {
    display: flex;
    margin-bottom: 10px;
  }
  .ipt-sty {
    flex: 1;
  }
  /deep/ .el-input__prefix {
    top: -4px !important;
  }
  a.txt-color + a.txt-color::before {
    content: '|';
    display: inline-block;
  }
.tab-wrap {
  background: #fff;

}

/deep/ .el-tabs__nav {
  margin-left: 10px;
}
  </style>
  
